import { Author, Image, Link, Taxonomies } from "@customTypes/index";
import { PresentationFields, Routes } from "@lib/constants";
import { Col, Row, Space, Tag } from "antd";
interface FlagCtaProps {
  className?: string;
  flip?: string;
  title?: string;
  date?: string;
  imgRatio?: string;
  authors?: Author[];
  layout?: number[];
  showFields?: string[];
  description?: string;
  link?: Link;
  image?: Image;
  taxonomies?: Taxonomies | null;
}

const defaultProps: FlagCtaProps = {
  className: "",
  title: "",
};

const FlagCta = ({
  className, title, authors, date, imgRatio, showFields, description, link, flip, image, layout, taxonomies,
}: FlagCtaProps) => {
  const direction: any = flip === 'start' ? 'row-reverse' : '';
  const [left, right] = layout ?? [8, 16];

  return (
    <Row className={`covr-cta-flag ${className}`}>
      <Col span={24}>
        <Row
          gutter={[10, 10]}
          style={{
            flexDirection: direction,
          }}>
          <Col className="image" xs={12} lg={left}>
            <a target={link?.target} href={link?.url}>
              <img
                style={{
                  objectPosition: `${image?.focalPoint?.left}% ${image?.focalPoint?.top}%`
                }}
                alt={image?.alt}
                className="responsive-img"
                src={image?.src}
                loading="lazy"
              />
            </a>
          </Col>
          <Col className="details" xs={12} lg={right}>
            <a target={link?.target} href={link?.url}>
              {title
                  && showFields?.includes(PresentationFields.TITLE)
                  && <Row>
                    <Col span={24}>
                        <h3>{title}</h3>
                    </Col>
                  </Row>}

              {date
                  && showFields?.includes(PresentationFields.DATE)
                  && <Row>
                    <Col span={24}>
                        <h4>{date}</h4>
                    </Col>
                  </Row>}
              {description
                  && showFields?.includes(PresentationFields.DESCRIPTION)
                  && <Row>
                    <Col span={24}>
                        <p className="line-clamp-3 text-grey">
                          {description}
                        </p>
                    </Col>
                  </Row>}
                </a>
              <Row>
                {taxonomies?.category
                    && showFields?.includes(PresentationFields.CATEGORY)
                    && <Col span={24}>
                      <Space className={`mar-bot-5`} size={[5, 5]} wrap>
                        {taxonomies.category.map((cat) =>
                            <Tag key={cat.id} color={`${cat.color}`}>
                              <a href={`${Routes.COLLECTOR_CONTENT_SEARCH}/?terms=${cat.id}`}>
                                {cat.name}
                              </a>
                            </Tag>
                        )}
                      </Space>
                    </Col>}
                {taxonomies?.tags
                    && showFields?.includes(PresentationFields.TAGS)
                    && <Col span={24}>
                      <Space className={`mar-bot-5`} size={[5, 5]} wrap>
                        {taxonomies.tags.map((tag) =>
                            <Tag key={tag.id} color={`${tag.color}`}>
                              <a href={`${Routes.COLLECTOR_CONTENT_SEARCH}/?terms=${tag.id}`}>
                                {tag.name}
                              </a>
                            </Tag>
                        )}
                      </Space>
                    </Col>}
              </Row>
          </Col>
        </Row>
      </Col>
    </Row>
);
};

FlagCta.defaultProps = defaultProps;

export default FlagCta;
